import React from 'react';
import { CheckableButton } from "components/CheckableButton/CheckableButton";

interface RadioSelectSettingsProps {
    direction: boolean;
    setDirection: (value: boolean) => void;
    object: any;
}

export const RadioSelectSettings: React.FC<RadioSelectSettingsProps> = ({
    direction,
    setDirection,
    object
}) => {
    return (
        <div className="my-1 row">
            <div className="col-6">
                <div className="d-flex align-items-end w-100 h-100">
                    <CheckableButton
                        type="checkradio"
                        labelText="vertical"
                        inputName="direction"
                        labelFalseText="Horizontal"
                        onchange={(e) => setDirection(e)}
                        checked={direction}
                        defaultChecked={object?.direction === 'true'}
                        defaultValue={object?.direction === 'true'}
                    />
                </div>
            </div>
        </div>
    );
}; 